"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const parseObjectToFormData = obj => {
  const formData = new FormData();
  for (const key in obj) {
    formData.append(key, obj === null || obj === void 0 ? void 0 : obj[key]);
  }
  return formData;
};
var _default = exports.default = parseObjectToFormData;